import React from "react";
import "../styles/PolicyPages.css";

const GizlilikPolitikasi = () => {
  return (
    <div className="policy-page">
      <h1>Gizlilik Politikası</h1>
      <p>
        <strong>Son Güncelleme:</strong> 09.04.2026
      </p>
      <p>
        Patili Dostlar ("Platform", "Biz" veya "Şirket") olarak, hayvan
        sahiplendirme hizmetlerimizi sunarken ziyaretçilerimizin, üyelerimizin
        ve başvuru sahiplerinin kişisel verilerinin korunmasına önem veriyoruz.
        Bu Gizlilik Politikası, Platform üzerinden toplanan kişisel verilerin
        hangi kapsamda işlendiğini, saklandığını, aktarıldığını ve ilgili kişi
        olarak haklarınızı açıklamaktadır.
      </p>
      <p>
        Bu politika, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve
        ilgili mevzuat hükümleri esas alınarak hazırlanmıştır.
      </p>

      <h3>1. Tanımlar</h3>
      <ul>
        <li>
          <strong>Kişisel Veri:</strong> Kimliği belirli veya belirlenebilir
          gerçek kişiye ilişkin her türlü bilgi.
        </li>
        <li>
          <strong>Özel Nitelikli Kişisel Veri:</strong> KVKK kapsamında sınırlı
          olarak sayılan ve daha yüksek koruma gerektiren veri kategorileri.
        </li>
        <li>
          <strong>Veri Sorumlusu:</strong> Kişisel verilerin işleme amaç ve
          vasıtalarını belirleyen Patili Dostlar platform işletmecisi.
        </li>
      </ul>

      <h3>2. Toplanan Kişisel Veriler</h3>
      <p>
        Platformun kullanımı sırasında aşağıdaki kişisel veriler işlenebilir:
      </p>
      <ul>
        <li>
          Kimlik ve iletişim bilgileri: ad, soyad, e-posta adresi, telefon
          numarası, adres bilgisi.
        </li>
        <li>
          Başvuru ve süreç verileri: sahiplendirme başvuru formunda paylaşılan
          bilgiler, başvuru değerlendirme kayıtları, sözleşme süreçlerine
          ilişkin veriler.
        </li>
        <li>
          Teknik veriler: IP adresi, cihaz bilgisi, tarayıcı türü, tarih-saat ve
          kullanım logları.
        </li>
        <li>
          İletişim verileri: destek talepleri, form içerikleri ve geri bildirim
          kayıtları.
        </li>
      </ul>
      <p>
        Özel nitelikli kişisel veriler, yalnızca kanuni şartların varlığı
        halinde veya açık rıza alınarak ve sınırlı ölçüde işlenir.
      </p>

      <h3>3. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebepleri</h3>
      <p>
        Kişisel verileriniz; üyelik oluşturma, form doldurma, sahiplendirme
        başvurusu, e-posta/telefon iletişimi ve benzeri otomatik veya otomatik
        olmayan yöntemlerle toplanır.
      </p>
      <p>Veriler aşağıdaki hukuki sebeplere dayanarak işlenir:</p>
      <ul>
        <li>Açık rızanın bulunması.</li>
        <li>Bir sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması.</li>
        <li>Hukuki yükümlülüğün yerine getirilmesi.</li>
        <li>Bir hakkın tesisi, kullanılması veya korunması.</li>
        <li>
          Temel hak ve özgürlüklerinize zarar vermemek kaydıyla meşru
          menfaatlerimizin bulunması.
        </li>
      </ul>

      <h3>4. Kişisel Verilerin İşlenme Amaçları</h3>
      <ul>
        <li>
          Sahiplendirme süreçlerinin yürütülmesi ve başvuruların
          değerlendirilmesi.
        </li>
        <li>Üyelik hesaplarının oluşturulması, doğrulanması ve yönetilmesi.</li>
        <li>Kullanıcılarla iletişim kurulması ve bildirim yapılması.</li>
        <li>
          Platform güvenliğinin sağlanması, kötüye kullanım ve dolandırıcılığın
          önlenmesi.
        </li>
        <li>
          Hizmet kalitesinin artırılması, performans ve kullanım analizlerinin
          yapılması.
        </li>
        <li>Yasal yükümlülüklerin yerine getirilmesi.</li>
        <li>
          Açık rıza bulunması halinde bilgilendirme ve pazarlama faaliyetlerinin
          yürütülmesi.
        </li>
      </ul>

      <h3>5. Kişisel Verilerin Aktarılması</h3>
      <p>
        Kişisel verileriniz, KVKK ve ilgili mevzuata uygun olarak ve gerekli
        güvenlik tedbirleri alınarak aşağıdaki taraflarla paylaşılabilir:
      </p>
      <ul>
        <li>
          Yetkili kamu kurum ve kuruluşları (yasal zorunluluk hallerinde).
        </li>
        <li>
          Hizmet sağlayıcılar ve iş ortakları (barındırma, e-posta, altyapı,
          destek hizmetleri vb.).
        </li>
        <li>
          Hukuki, mali ve denetim danışmanları (hukuki yükümlülük kapsamında).
        </li>
      </ul>
      <p>
        Yurt dışı aktarım, yalnızca mevzuatta öngörülen şartların sağlanması
        halinde veya açık rızanıza dayanılarak gerçekleştirilir.
      </p>

      <h3>6. Saklama Süreleri</h3>
      <p>
        Kişisel verileriniz, işleme amacının gerektirdiği süre boyunca ve ilgili
        mevzuatta öngörülen saklama süreleri kadar muhafaza edilir. Süre sonunda
        veriler; silme, yok etme veya anonim hale getirme yöntemleriyle imha
        edilir.
      </p>

      <h3>7. Veri Güvenliği</h3>
      <p>
        Veri güvenliğini sağlamak amacıyla yürürlükteki mevzuat ve sektör
        uygulamalarına uygun makul teknik ve idari tedbirler alınmaktadır. Bu
        kapsamda erişim kontrolü, loglama, şifreleme, ağ güvenliği ve düzenli
        yedekleme mekanizmaları kullanılmaktadır. Ancak internet altyapısının
        doğası gereği veri iletimlerinin kesintisiz ve mutlak güvenliği teknik
        olarak garanti edilemez. Platform, kendi kontrol alanı dışında gelişen;
        üçüncü kişiler tarafından gerçekleştirilen hukuka aykırı siber
        saldırılar, hizmet kesintileri, yetkisiz erişimler veya benzeri dış
        kaynaklı olaylardan doğabilecek zararlardan, mevzuatın emredici
        hükümleri saklı kalmak kaydıyla, yalnızca kusuru oranında sorumludur.
      </p>

      <h3>8. İlgili Kişi Hakları (KVKK Madde 11)</h3>
      <p>KVKK kapsamında aşağıdaki haklara sahipsiniz:</p>
      <ul>
        <li>Kişisel verinizin işlenip işlenmediğini öğrenme.</li>
        <li>İşlenmişse buna ilişkin bilgi talep etme.</li>
        <li>
          İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme.
        </li>
        <li>
          Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme.
        </li>
        <li>Eksik veya yanlış işlenmiş verilerin düzeltilmesini isteme.</li>
        <li>
          KVKK'da öngörülen şartlar çerçevesinde silme veya yok edilmesini
          isteme.
        </li>
        <li>
          Yapılan düzeltme, silme veya yok etme işlemlerinin aktarıldığı üçüncü
          kişilere bildirilmesini isteme.
        </li>
      </ul>

      <h3>9. Politika Değişiklikleri</h3>
      <p>
        Bu Gizlilik Politikası, yasal düzenlemeler veya operasyonel ihtiyaçlar
        doğrultusunda güncellenebilir. Güncel metin Platform üzerinde
        yayımlandığı tarihten itibaren geçerlilik kazanır.
      </p>

      <p>
        Platforma kayıt olan her kullanıcı, işbu Gizlilik Politikası'nı okumuş,
        anlamış ve kabul etmiş sayılır.
      </p>

      <h3>10. İletişim</h3>
      <p>
        Gizlilik Politikası kapsamındaki talepleriniz için bizimle aşağıdaki
        e-posta adresi ve diğer iletişim kanalları üzerinden iletişime
        geçebilirsiniz:
      </p>
      <ul>
        <li>
          <strong>Şirket Adı:</strong> Patili Dostlar
        </li>
        <li>
          <strong>Adres:</strong> [Adres Bilgisi Eklenecek]
        </li>
        <li>
          <strong>E-posta:</strong> [E-posta Adresi Eklenecek]
        </li>
        <li>
          <strong>Telefon:</strong> [Telefon Numarası Eklenecek]
        </li>
      </ul>
      <p>
        Başvurularınız, mevzuata uygun olarak en geç 30 gün içerisinde
        sonuçlandırılır.
      </p>
    </div>
  );
};
export default GizlilikPolitikasi;
